import { ProgressBar } from "processhub-components-lib";
import useScreen from "hooks/useScreen";
import { useVolumeContext } from "hooks/useProjectVolume";

const OverallProgress = () => {
  const { scanVolume, maxVolume } = useVolumeContext();
  const percentage = scanVolume && maxVolume ? (scanVolume / maxVolume) * 100 : 0;
  const { isScaled } = useScreen();
  const calculatedPercentage = percentage > 100 ? 100 : Number(percentage.toFixed());

  return (
    <div className="flex flex-wrap items-center justify-center">
      <h3>Overall Progress: {percentage.toFixed()}%</h3>
      <div className="w-full">
        <ProgressBar value={calculatedPercentage} className="h-[20px]" hasValueDisplay={false} height={isScaled ? 10 : 15} />
      </div>
    </div>
  );
};

export default OverallProgress;